import { createContext } from 'react';
import { DealRoomRequiredVisibleInfo } from 'models/DealRoom';
import { RequiredVisibleInfo } from 'models/Listing';
import utils from 'utils';

type DealRoomFieldsRequiredVisibleInfoContextProps = {
  fields: Partial<DealRoomRequiredVisibleInfo>;
  canChangeRequired: boolean;
  updateField: (
    fieldName: keyof DealRoomRequiredVisibleInfo,
    values: RequiredVisibleInfo,
    onSuccess: () => void,
  ) => Promise<void>;
};

export default createContext<
  Partial<DealRoomFieldsRequiredVisibleInfoContextProps>
>({
  fields: null,
  canChangeRequired: false,
  updateField: utils.noop,
});
